/**
 * Base URL for the qr-code-generator service (CloudFront distribution).
 * Callers append `?text=...` (plus rendering params) to get a QR PNG.
 */
export const QR_CODE_SERVICE_URL: string =
  import.meta.env.VITE_QR_CODE_SERVICE_URL || "https://d1z9fywttblej4.cloudfront.net";
